module.exports = __webpack_public_path__ + "static/media/caffe-nero.12a8fb5b.png";